import { z } from 'zod'

export const zPhoneNumber = z.string().min(6, { message: 'Numéro de téléphone invalide.' })

export const zOtpCode = z
  .string()
  .min(6, { message: 'Le code doit contenir 6 caractères' })
  .max(6, { message: 'Le code doit contenir 6 caractères' })
